/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { areAddressesTheSame } from "@insite/client-framework/Common/CustomerSelectors";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { updateBillTo } from "@insite/client-framework/Services/CustomersService";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import loadBillTo from "@insite/client-framework/Store/Data/BillTos/Handlers/LoadBillTo";
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import {
    chain,
    LoadCart,
    UpdateBillTo,
} from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/UpdateCart";
import { BaseAddressModel } from "@insite/client-framework/Types/ApiModels";

export const MONLoadCart: any = (props: any) => {
    const fullExpand = props.parameter.fullExpand;
    const state = props.getState();
    const { cartId } = state.pages.checkoutShipping;
    if (cartId) {
        props.dispatch(loadCart({ cartId, fullExpand } as any));
    } else {
        props.dispatch(loadCurrentCart({ fullExpand } as any));
    }
};

export const MONUpdateBillTo = async (props: any) => {
    const { dispatch, getState, cart } = props;
    const state = getState();
    const {
        pages: {
            checkoutShipping: { billingAddressFormState },
        },
    } = state;
    if (!billingAddressFormState) {
        return;
    }

    const billTo = getBillToState(state, cart.billToId).value;
    if (!billTo) {
        throw new Error("There was no billTo loaded for the current cart");
    }

    const { address: localModifiedBillTo } = billingAddressFormState;

    if (!areAddressesTheSame(billTo, localModifiedBillTo) || props.updatedShipTo) {
        props.updatedBillTo = await updateBillTo({
            billTo: localModifiedBillTo,
            isEdit: true,
        });

        dispatch(loadBillTo({ billToId: billTo.id }));

        props.apiParameter.cart.billToId = props.updatedBillTo.id;
    }
};

replaceInChain(chain, UpdateBillTo, MONUpdateBillTo);
replaceInChain(chain, LoadCart, MONLoadCart);
